<div class="container my-5">
  <div class="row justify-content-center">
    <div class=" col-md-12">
      <div class="card shadow">
        <div class="card-header bg-danger text-white">
          <h3 class="card-title text-center">Return / Refund Policy</h3>
        </div>
        <div class="card-body">
          <!-- Introduction Section -->
          <section class="mb-5">
            <h4 class="text-danger mb-4">Introduction</h4>
            <p>
              Products delivered from <strong>SmartDukaan</strong> outlets can only be returned at the same outlet it was delivered in the original condition.
            </p>
            <p>
              Sealed opened/box tampered products will not be eligible for return.
            </p>
            <p>
              Products can only be exchanged, and there is no refund policy.
            </p>
          </section>

          <!-- Return Policy Section -->
          <section class="mb-5">
            <h4 class="text-danger mb-4">Return Policy</h4>
            <ul>
              <li class="mb-3">
                <strong>Original Condition:</strong> Products must be returned in their original condition, including all accessories, packaging, and documentation.
              </li>
              <li class="mb-3">
                <strong>Sealed Products:</strong> Sealed or tampered boxes are not eligible for return.
              </li>
              <li class="mb-3">
                <strong>Exchange Only:</strong> Products can only be exchanged; no refunds will be provided.
              </li>
              <li class="mb-3">
                <strong>Transit Orders:</strong> If the order is still in transit, it can be canceled at zero cost.
              </li>
              <li class="mb-3">
                <strong>Advance Payments:</strong> In case of advance payments, the money will be refunded within 7 days.
              </li>
              <li class="mb-3">
                <strong>Faulty Products:</strong> If there is any fault in the product, the nearest service center will be able to fix it for the customer.
              </li>
            </ul>

            <h4 class="text-danger mb-4">Open-Box Laptops – Return &amp; Refund Policy</h4>
            <ol>
              <li class="mb-3">
                <b>Condition of Product</b>
                <ul class="mt-2">
                  <li class="mb-3">Product must be returned in its <b>original physical condition</b>.</li>
                  <li class="mb-3">All <b>accessories, packaging, manuals, and documentation</b> must be included.</li>
                  <li class="mb-3">Products with <b>altered, missing contents</b>, or <b>tampered packaging</b> will not be accepted for return.</li>
                </ul>
              </li>
              <li class="mb-3">
                <b>Reporting Issues</b>
                <ul class="mt-2">
                  <li class="mb-3">Any issue such as <b>damage, non-functioning product, or missing accessories</b> must be reported <b>within 24 hours</b> of delivery.</li>
                  <li class="mb-3">Reports made <b>after 24 hours</b> may not qualify for exchange or refund.</li>
                </ul>
              </li>
              <li class="mb-3">
                <b>Exchange Options</b>
                <ul class="mt-2">
                  <li class="mb-3"><b>Same Product Exchange</b> – Exchange for the same model (subject to stock availability).</li>
                  <li class="mb-3"><b>Different Product Exchange</b> – Exchange for another model, with price difference adjusted (extra amount paid or refund issued).</li>
                  <li class="mb-3"><b>Full Refund</b> – Available only if reported within the 24-hour window and in cases where
                    an alternate product is not available (at the sole discretion of management).</li>
                </ul>
              </li>
              <li class="mb-3">
                <b>Advance Payments</b>
                <ul class="mt-2">
                  <li class="mb-3">If advance payment is made and the order is cancelled before dispatch or while in
                    transit, the <b>full amount</b> will be refunded within <b>14–21 business days</b>.</li>
                </ul>
              </li>
              <li class="mb-3">
                <b>Faulty Product Support (After 24 Hours)</b>
                <ul class="mt-2">
                  <li class="mb-3">If a product develops a fault after the 24-hour reporting window, assistance will be
                    provided through the <b>nearest authorized service center</b>.</li>
                  <li class="mb-3">For any other <b>service-related queries</b>, please contact the <b>authorized service center</b> directly.</li>
                </ul>
              </li>
            </ol>
          </section>

          <!-- Additional Information Section -->
          <section class="mb-5">
            <h4 class="text-danger mb-4">Additional Information</h4>
            <p>
              Customers may visit the nearest <strong>SmartDukaan</strong> outlet for any additional queries or assistance regarding returns and exchanges.
            </p>
          </section>

          <!-- Contact Information Section -->
          <section class="mb-5">
            <h4 class="text-danger mb-4">Contact Information</h4>
            <p>
              For further assistance, please contact us at:
            </p>
            <ul>
              <li class="mb-3">
                <strong>Company Name:</strong> New Spice Solutions Private Limited
              </li>
              <li class="mb-3">
                <strong>Address:</strong> Priska Tower, 2nd Floor, C-56/45, C Block,Industrial Area Phase 2 Sector 62, Noida - 201309 (UP)
              </li>
              <li class="mb-3">
                <strong>Telephone Number:</strong> <a href="tel:18002700273" class="text-decoration-none">1800 270 0273</a>
              </li>
              <li class="mb-3">
                <strong>E-Mail ID:</strong> <a href="mailto:care&#64;smartdukaan.com" class="text-decoration-none">care&#64;smartdukaan.com</a>
              </li>
            </ul>
          </section>
        </div>
      </div>
    </div>
  </div>
</div>
